<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="isLower1024 ? 'fs' : 'lg-fix-h'" :ariaLabel="header">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{header}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div 
        class="form-wrapper p-4 overflow-x-hidden"
        ref="containerSelect"
        style="max-height: 60vh"
        :style="{'height':heightContainerSelect}"
        >
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="px-4 flex -mx-2 flex-col lg:flex-row gap-x-6">
            <div class="w-full mb-6 md:mb-0 ">
              <div v-if="(role === 7 || role === 8 || role === 3)">

                <AccessibleElSelect
                  prop="idCliente"
                  v-model="form.idCliente"
                  :options="clientes.map(c => ({ id: c.idCliente, name: c.Nombre }))"
                  id-prefix="importcert"
                >
                  <template #label>
                    <base-obligatory-icon/>{{$t('clients.entity_name')}}
                  </template>
                </AccessibleElSelect>

              </div>
              <div ref="value">
                <div class="flex items-center mb-1">
                  <label class="text-sm font-semibold text-secondary-600 block">{{headerValue}}</label>
                  <base-tooltip-icon size="sm" :content="msgTooltip" class="ml-2"/>
                </div>
                <el-form-item prop="value">
                  <el-input
                    ref="passwordInput"
                    clearable
                    type="text"
                    class="w-full"
                    v-model="form.value"
                    maxlength='100'
                    show-password
                    :placeholder="headerValue"
                    autocomplete="new-password"
                  />
                </el-form-item>
              </div>
              <div>
                <label for="id-switch-import-cert" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{switchHeaderValue}}
                  <span class="sr-only">{{$t('app.options')}}: {{switchHeaderValueInactive}} / {{switchHeaderValueActive}}</span>
                </label>
                <el-switch 
                  id="id-switch-import-cert"
                  :aria-label="switchHeaderValue"
                  class="switch-text break-normal both-switch block" 
                  v-model="form.switch" 
                  :active-text="switchHeaderValueActive"
                  :inactive-text="switchHeaderValueInactive" 
                  inactive-color="var(--primary-800)"
                  />
              </div>
            </div>
            <div class="px-2 mb-2 lg:mb-0">
              <label class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('app.certificates_pfx')}}</label>
              <el-form-item prop="files" ref="uploadpfxref">
                <Upload
                  role="button"
                  ref="upload"
                  accept=".pfx"
                  id="pfxselectorimport"
                  class="bg-white dark:bg-darkblue-900 "
                  :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                  drag
                  multiple
                  action="#"
                  :auto-upload=false
                  :show-file-list="true"
                  :limit="this.maxFiles"
                  :on-remove="handleRemove"
                  :on-change="handleChange"
                  :on-exceed="handleOnExceed"
                  >
                  <i class="el-icon-upload"></i>
                  <p v-if="files && files.length" class="el-upload__text"><em>{{this.fileNames}}</em></p>
                  <div v-else class="el-upload__text" v-html="$tc('app.upload_default_no_file_text', 1)"></div>
                </Upload>
              </el-form-item>
            </div>
          </div>
          
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <div class="w-full flex items-center gap-x-2">
        <base-button @click="toggleDialog" class="w-full" mode="secondary-phantom-blue" :text="$t('app.cancel')" />
        <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.accept')" @click="apply('ruleForm')" />
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import { getClients } from '@/services/clients/getClients'
import { Upload } from 'element-ui'
import { i18n } from '@/i18n'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'input-text-dialog',
  components: {
    BaseDialogButton,
    Upload,
    AccessibleElSelect,
  },
  props: {
    header: {
      type: String,
      default: i18n.t('app/important')
    },
    headerValue: {
      type: String,
      default: i18n.t('app/value')
    },
    switchHeaderValue: {
      type: String,
      default: i18n.t('app/choose')
    },
    switchHeaderValueActive: {
      type: String,
      default: i18n.t('app/active')
    },
    switchHeaderValueInactive: {
      type: String,
      default: i18n.t('app/not_active')
    },
    dialogOpen: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: [Number, String],
      default: -1
    }
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 64,
      isOpen: this.dialogOpen,
      files: [],
      form: {
        value: '',
        switch: true,
        idCliente: null,
      },
      maxFiles: 500,
      msgTooltip: this.$i18n.t('tooltip.import_pfx'),
      clientes: [],
      rules: {
        idCliente: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        value: [
          {
            required: false,
            message: this.$i18n.t('validation.complete'),
            trigger: 'blur'
          }
        ],
        files: [
          {
            message: this.$i18n.t('app.fill_data'),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNames) {
                callback(new Error(i18n.t('validation.complete')))
              } else {
                callback()
              }
            }
          },
          {
            message: i18n.t('validation.not_single_valid_extension', { ext: '.pfx' }),
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.files.forEach(archivo => {
                if (archivo.name.length < 5 || 
                  !['.PFX'].includes(archivo.name.substr(archivo.name.length - 4).toUpperCase())) {
                  invalidExtension = true
                }
              })
              if (invalidExtension) {
                callback(new Error(i18n.t('validation.not_single_valid_extension', { ext: '.pfx' })))
              } else {
                callback()
              }
            }
          }
        ]
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.form.value = ''
      this.form.switch = true
      this.form.idCliente = null
      this.files = []
      if (value) {
        this.loadClients()
      } else {
        this.clientes = []
      }
    }
  },
  mounted: async function () {
    // this.$nextTick(() => {
    //   // Timeout para esperar a que se rendericen los iconos
    //   setTimeout(() => {
    //     this.fixAccesibilityElInputPassword(this.$refs.passwordInput, this.$i18n.t('aria.elementui.input.password'))
    //   }, 1000)
    // })
  },
  computed: {
    clientFilter: function () {
      return this.$store.getters['app/idClienteFilterUpload']?.idCliente
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    fileNames () {
      if (this.files === null || this.files.length === 0) {
        return ''
      } else if (this.files.length === 1) {
        return this.files[0].name
      } else {
        return '(' + this.files.length + ') ' + i18n.t('app.files')
      }
    },
  },
  methods: {
    handleChange: function (file) {
      this.$refs.uploadpfxref.clearValidate()
      this.files.push(file)
    },
    handleRemove: function (file) {
      this.files = this.files.filter(x => x.uid !== file.uid)
    },
    handleOnExceed: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.maxFilesAdj }), 'warning')
    },
    loadClients: async function () {
      if (this.role === 7|| this.role === 8 || this.role === 3) {
        const dataClients = await getClients()
        if (dataClients.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', dataClients))
        } else {
          this.clientes = dataClients.Clientes
          this.form.idCliente = this.clientFilter || ''
        }
      }
    },
    toggleDialog: function () {
      if (this.dialogOpen && this.isLoadingSelect) return
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    apply: async function (ruleForm) {
      this.$refs[ruleForm].validate(async valid => {
        if (valid) {
          this.isOpen = !this.isOpen
          this.$emit('applyDialog', this.files, this.form)
        } else {
          this.doFeedback(i18n.t('feedback.error.process_data_error'))
        }
      })
    },
  }
}
</script>
